import Typography from '@mui/material/Typography';
import '@/Pages/Error/ErrorPage.sass';

type ErrorCodeProps = {
  errorCode?: string;
};

export function ErrorCode({ errorCode }: ErrorCodeProps): JSX.Element | null {
  if (!errorCode) {
    return null;
  }

  return (
    <Typography
      component="p"
      className="error-code"
      data-testid="error-code"
    >
      {errorCode}
    </Typography>
  );
}
